const stylesDQ = {
  containerDetailsQdr: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    minHeight: '20%',
    height: 'auto',
    padding: '10px',
    marginTop: '5px',
    borderRadius: 'var(--border-radius-mid)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: 'inherit',
      zIndex: 1,
    },
    zIndex: 2,
  },
  containerIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    height: '100%',
    zIndex: 3,
  },
  content: {
    position: 'relative',
    zIndex: 3,
  },
  titleQuadra: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 'var(--text-size-h2)',
  },
  titleEmpresa: {
    color: 'var(--color-text-hig)',
    fontWeight: 'bold',
    fontSize: 'var(--text-size-h3)',
  },
  labelQuadra: {
    color: 'var(--color-text-sec)',
    fontSize: 'var(--text-size-h3)',
  },
}

export default stylesDQ
